import React, { useEffect, useState } from 'react'

import axios from '../../utils/axios'
import useAuth from '../../context/hook/useAuth'

export const Deposit = () => {

    const {user} = useAuth()

    const [deposit, setDeposit] = useState([])

    const despositCheck = async () => {
        try {
            await axios.get(`/deposit/detail`,
                {
                    headers:{
                        "Content-Type": "application/json",
                        "Authorization":user
                    },
                    withCredentials:true,
                }
            ).then((res)=>{
                let data = JSON.parse(res.data)
                // console.log(data)
                setDeposit(data)
            }).catch(err=>{
                console.log(err)
            })
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(()=>{
        despositCheck()
        // eslint-disable-next-line
    },[])

  return (
    <div>
        <div className="wallet-history">
            <div className="table-responsive">
                <table className="table">
                    <thead>
                    <tr>
                        <th scope="col">Date &amp; Time</th>
                        <th scope="col">Coin</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Type</th>
                        <th scope="col">Transaction Id</th>
                        <th scope="col">Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        deposit&&deposit.map((item,index)=>{
                            return(
                                <React.Fragment key={index}>
                                    <tr key={index}>
                                        <td>{item.Time}</td>
                                        <td>{item.TypeOf}</td>
                                        <td>{item.Amount}</td>
                                        <td>{item.Type}</td>
                                        <td>{item.Transaction_Id}</td>
                                        <td className={item.Status ==="Completed" ? "clr-green" : item.Status ==="Rejected" ? "clr-red" : '' }>{item.Status === 'Not Approval' ? "Pending" : item.Status }</td>
                                    </tr>
                                </React.Fragment>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  )
}
